import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { KomitentZrc } from './komitent-zrc';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-komitent-zrc-modal-update',
  templateUrl: './komitent-zrc-modal-update.component.html'
})
export class KomitentZrcModalUpdateComponent extends BaseModalUpdateComponent<KomitentZrc> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentZrc>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
